/**
 * 使用：
 * v-webim-tip.hover.delay="$tipRef"
 * v-webim-tip:tipRef.hover
 * delay 只针对hover生效
 */
import Vue from 'vue';
import Tip from './index';

// 全局注册组件
Vue.component('v-webim-tip', Tip);

Vue.directive('webim-tip', {
  bind(el, binding, vnode) {
    const ref = binding.arg || binding.expression;
    const target = vnode.context.$refs[ref];
    if (!target) {
      console.error('Tip component not found');
      return;
    }

    // 默认为 hover 事件
    const eventType = binding.modifiers.click ? 'click' : 'hover';
    const delay = binding.modifiers.delay ? 300 : 0;

    let timer = null;

    if (eventType === 'hover') {
      el.addEventListener('mouseenter', () => {
        clearTimeout(timer);
        target.show(el);
      });
      el.addEventListener('mouseleave', () => {
        timer = setTimeout(() => {
          target.hide();
        }, delay);
      });

      target.$el.addEventListener('mouseenter', () => {
        clearTimeout(timer);
        target.show(el);
      });
      target.$el.addEventListener('mouseleave', () => {
        timer = setTimeout(() => {
          target.hide();
        }, delay);
      });
    } else if (eventType === 'click') {
      el.addEventListener('click', (e) => {
        e.stopPropagation();

        if (target.isHidden) {
          target.show(el);
        } else {
          target.hide();
        }
      });

      document.body.addEventListener('click', (e) => {
        if (!target) {
          return;
        }

        // 如果点击的是tip本身，则不处理。
        if (target.$el.contains(e.target)) {
          return;
        }

        if (!target.isHidden) {
          target.hide();
        }
      });
    }
  },
});

